export enum InvoiceStatus {
  PENDING = 1,
  APPROVED = 2,
  PAID = 3,
  UNAPPROVED = 4,
  INACTIVE = 9,
}
